// components/common/StatusChip.tsx
import React from 'react';
import { Chip, ChipProps } from '@mui/material';
import {
  CheckCircle as VerifiedIcon,
  Schedule as PendingIcon,
  Cancel as DeletedIcon,
} from '@mui/icons-material';

interface StatusChipProps {
  status: 'PENDING' | 'VERIFIED' | 'DELETED';
  size?: 'small' | 'medium';
  variant?: 'filled' | 'outlined';
}

const StatusChip: React.FC<StatusChipProps> = ({ 
  status, 
  size = 'small',
  variant = 'filled'
}) => {
  const config = {
    PENDING: {
      color: 'warning' as const,
      icon: <PendingIcon />,
      label: 'Pending',
    },
    VERIFIED: {
      color: 'success' as const,
      icon: <VerifiedIcon />,
      label: 'Verified',
    },
    DELETED: {
      color: 'error' as const,
      icon: <DeletedIcon />,
      label: 'Deleted',
    },
  };

  const { color, icon, label } = config[status] || config.PENDING;

  return (
    <Chip
      icon={icon}
      label={label}
      color={color}
      size={size}
      variant={variant}
      sx={{ 
        fontWeight: 600,
        '& .MuiChip-icon': {
          fontSize: size === 'small' ? 16 : 20,
        }
      }}
    />
  );
};

export default StatusChip;